/**
 * Force EGP currency code instead of E£ / LE symbols across the storefront.
 */
(function () {
  const SYMBOL_RE = /(?:E\s*£|£\s*E|\bLE\b|ج\.?\s*م\.?)/gi;
  let scheduled = false;
  let patching = false;

  function normalizeMoneyText(text) {
    if (!text || typeof text !== 'string') return text;
    if (!SYMBOL_RE.test(text) && !/\bEGP\s+EGP\b/i.test(text)) return text;
    SYMBOL_RE.lastIndex = 0;
    let t = text.replace(SYMBOL_RE, ' ').replace(/\s+/g, ' ').trim();
    t = t.replace(/(?:EGP\s*)+/gi, '').trim();
    if (!t) return text;
    if (/^[\d.,]/.test(t)) return 'EGP ' + t;
    return 'EGP ' + t;
  }

  function walk(node) {
    if (!node || patching) return;
    if (node.nodeType === Node.TEXT_NODE) {
      const next = normalizeMoneyText(node.nodeValue);
      if (next && next !== node.nodeValue) node.nodeValue = next;
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    const tag = node.tagName;
    if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'NOSCRIPT' || tag === 'TEXTAREA') return;
    for (const child of Array.from(node.childNodes)) walk(child);
  }

  function fix(root) {
    if (patching) return;
    patching = true;
    try {
      const scope = root || document.body;
      if (!scope) return;
      scope
        .querySelectorAll('[data-money-format], [data-currency-format]')
        .forEach((el) => {
          ['data-money-format', 'data-currency-format'].forEach((attr) => {
            if (el.hasAttribute(attr)) el.setAttribute(attr, 'EGP {{amount}}');
          });
        });
      walk(scope);
    } finally {
      patching = false;
    }
  }

  function schedule() {
    if (scheduled || patching) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      fix(document.body);
    });
  }

  function patchShopifyFormatMoney() {
    if (!window.Shopify || typeof window.Shopify.formatMoney !== 'function') return;
    if (window.Shopify.__zoonyEgpPatched) return;
    const original = window.Shopify.formatMoney.bind(window.Shopify);
    window.Shopify.formatMoney = function (cents, format) {
      return normalizeMoneyText(original(cents, format || 'EGP {{amount}}'));
    };
    window.Shopify.__zoonyEgpPatched = true;
  }

  const boot = () => {
    patchShopifyFormatMoney();
    fix(document.body);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('cart:updated', schedule);
  document.addEventListener('variant:change', schedule);
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
